export function raiseInvalidFrequencyFlag(
  fieldName:
    | "onceADay"
    | "twiceADayInputOne"
    | "twiceADayInputTwo"
    | "threeTimesADayInputOne"
    | "threeTimesADayInputTwo"
    | "threeTimesADayInputThree",
  frequencyFieldControls: any
) {
  if (fieldName == "onceADay") {
    frequencyFieldControls.onceADayInput = true;
  } else if (fieldName == "twiceADayInputOne") {
    frequencyFieldControls.twiceADayOne = true;
  } else if (fieldName == "twiceADayInputTwo") {
    frequencyFieldControls.twiceADayTwo = true;
  } else if (fieldName == "threeTimesADayInputOne") {
    frequencyFieldControls.threeTimesADayOne = true;
  } else if (fieldName == "threeTimesADayInputTwo") {
    frequencyFieldControls.threeTimesADayTwo = true;
  } else if (fieldName == "threeTimesADayInputThree") {
    frequencyFieldControls.threeTimesADayThree = true;
  }

  return frequencyFieldControls;
}

export function setFrequencyValues(
  frequencyName: any,
  value: any,
  frequencyFields: any
) {
  if (frequencyName == "onceADay") {
    frequencyFields.onceADayTimeInput = value;
  } else if (frequencyName == "twiceADayInputOne") {
    frequencyFields.twiceADayInputOne = value;
  } else if (frequencyName == "twiceADayInputTwo") {
    frequencyFields.twiceADayInputTwo = value;
  } else if (frequencyName == "threeTimesADayInputOne") {
    frequencyFields.threeTimesADayInputOne = value;
  } else if (frequencyName == "threeTimesADayInputTwo") {
    frequencyFields.threeTimesADayInputTwo = value;
  } else if (frequencyName == "threeTimesADayInputThree") {
    frequencyFields.threeTimesADayInputThree = value;
  }

  return frequencyFields;
}

export function setFrequencyInputFieldErrors(
  fieldName: any,
  frequencyErrorFields: any
) {
  if (fieldName == "onceADay") {
    frequencyErrorFields.errorOnceADayInput = true;
    frequencyErrorFields.errorTwiceADayInputOne = false;
    frequencyErrorFields.errorTwiceADayInputTwo = false;
    frequencyErrorFields.errorThreeTimesADayInputOne = false;
    frequencyErrorFields.errorThreeTimesADayInputTwo = false;
    frequencyErrorFields.errorThreeTimesADayInputThree = false;
  } else if (fieldName == "twiceADayInputOne") {
    frequencyErrorFields.errorTwiceADayInputOne = true;
    frequencyErrorFields.errorOnceADayInput = false;
    frequencyErrorFields.errorThreeTimesADayInputOne = false;
    frequencyErrorFields.errorThreeTimesADayInputTwo = false;
    frequencyErrorFields.errorThreeTimesADayInputThree = false;
  } else if (fieldName == "twiceADayInputTwo") {
    frequencyErrorFields.errorTwiceADayInputTwo = true;
    frequencyErrorFields.errorOnceADayInput = false;
    frequencyErrorFields.errorThreeTimesADayInputOne = false;
    frequencyErrorFields.errorThreeTimesADayInputTwo = false;
    frequencyErrorFields.errorThreeTimesADayInputThree = false;
  } else if (fieldName == "threeTimesADayInputOne") {
    frequencyErrorFields.errorThreeTimesADayInputOne = true;
    frequencyErrorFields.errorOnceADayInput = false;
    frequencyErrorFields.errorTwiceADayInputOne = false;
    frequencyErrorFields.errorTwiceADayInputTwo = false;
  } else if (fieldName == "threeTimesADayInputTwo") {
    frequencyErrorFields.errorThreeTimesADayInputTwo = true;
    frequencyErrorFields.errorOnceADayInput = false;
    frequencyErrorFields.errorTwiceADayInputOne = false;
    frequencyErrorFields.errorTwiceADayInputTwo = false;
  } else if (fieldName == "threeTimesADayInputThree") {
    frequencyErrorFields.errorThreeTimesADayInputThree = true;
    frequencyErrorFields.errorOnceADayInput = false;
    frequencyErrorFields.errorTwiceADayInputOne = false;
    frequencyErrorFields.errorTwiceADayInputTwo = false;
  }

  return frequencyErrorFields;
}

export function clearFrequencyInputFieldErrors(
  fieldName: any,
  frequencyErrorFieldValues: any,
  frequencyErrorFieldControls: any
) {
  if (fieldName == "onceADay") {
    frequencyErrorFieldValues.errorOnceADayInput = false;
    frequencyErrorFieldControls.onceADayInput = null;
  } else if (fieldName == "twiceADayInputOne") {
    frequencyErrorFieldValues.errorTwiceADayInputOne = false;
    frequencyErrorFieldControls.twiceADayOne = null;
  } else if (fieldName == "twiceADayInputTwo") {
    frequencyErrorFieldValues.errorTwiceADayInputTwo = false;
    frequencyErrorFieldControls.twiceADayTwo = null;
  } else if (fieldName == "threeTimesADayInputOne") {
    frequencyErrorFieldValues.errorThreeTimesADayInputOne = false;
    frequencyErrorFieldControls.threeTimesADayOne = null;
  } else if (fieldName == "threeTimesADayInputTwo") {
    frequencyErrorFieldValues.errorThreeTimesADayInputTwo = false;
    frequencyErrorFieldControls.threeTimesADayTwo = null;
  } else if (fieldName == "threeTimesADayInputThree") {
    frequencyErrorFieldValues.errorThreeTimesADayInputThree = false;
    frequencyErrorFieldControls.threeTimesADayThree = null;
  }

  return { frequencyErrorFieldValues, frequencyErrorFieldControls };
}

export function formatTwentyFourHourTimeInputField(value: any) {
  if (!value) {
    value = "";
  }

  value = value.replace(/[^0-9]/g, "");

  if (value[0] > "2") {
    value = "";
  }

  if (value.length == 2) {
    if (value[0] == "2" && value[1] >= "4") {
      value = value[0];
    }
  }

  if (value.length >= 3) {
    if (value[2] >= "6") {
      value = value.slice(0, 2);
    } else {
      value = value.slice(0, 2) + ":" + value.slice(2, 4);
    }
  }

  if (value.length > 5) {
    value = value.slice(0, 5);
  }

  return value;
}

export function getTotalPages(totalItems: any, rowsPerPage: any) {
  return Math.ceil(totalItems / rowsPerPage);
}

export function formatTimeTwentyFourHour(
  hours: number,
  minutes: number
): string {
  const hour = hours.toString().padStart(2, "0");
  const minute = minutes.toString().padStart(2, "0");
  return `${hour}:${minute}`;
}

export function setFrequencyTime(timeString: string) {
  const [hours, minutes] = timeString.split(":").map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);

  return date;
}

export function validateFrequencyValue(raw: any) {
  let result = "";
  let hours = "";
  let minutes = "";
  let amPm = "";

  if (raw.length >= 1) {
    let h = raw.slice(0, 2);
    if (h.length === 1 && h >= 2) h = "0" + h;
    if (parseInt(h) > 12) h = "12";
    result = h;
    hours = h;
  }

  if (raw.length >= 3) {
    let m = raw.slice(2, 4);
    if (m.length === 1 && m >= 6) m = "0" + m;
    if (parseInt(m) > 59) m = "59";
    result += ":" + m;
    minutes = m;
  } else if (raw.length >= 2) {
    result += ":";
  }

  if (raw.length >= 5) {
    let ampm = raw
      .slice(4)
      .replace(/[^APM]/g, "")
      .toUpperCase();
    if (/^A/.test(ampm)) {
      ampm = "AM";
      result += " " + ampm;
      amPm = ampm;
    } else if (/^P/.test(ampm)) {
      ampm = "PM";
      result += " " + ampm;
      amPm = ampm;
    }
  }

  return {
    result,
    hours,
    minutes,
    amPm,
  };
}
